// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"daa49e73","65":"43e9ed9e","136":"8c693310","231":"67b087b2","371":"08f1ccce","394":"3e63ed38","452":"8feba3ea","501":"19e1e95a","629":"6d2ce1d3","643":"34074f73","897":"2e12b115"}[chunkId] + ".chunk.js";
};